// adapted from jquery code
// https://github.com/jquery/jquery/blob/d0ce00cdfa680f1f0c38460bc51ea14079ae8b07/src/offset.js

export default function offset(node) {
  // Get document-relative position by adding viewport scroll to viewport-relative gBCR
  const rect = node.getBoundingClientRect();
  const win = node.ownerDocument.defaultView;
  return {
    top: rect.top + win.pageYOffset,
    left: rect.left + win.pageXOffset
  };
}
